import { COMPUTERS_HAS_ERROR, COMPUTERS_IS_LOADING, COMPUTERS_FETCH_DATA_SUCCESS, COMPUTERS_CREATE_CACHE} from '../actions/computers'

   
export function computersHasError(state = null, action) {
    switch (action.type) {
        case COMPUTERS_HAS_ERROR:
            return action.error;

        default:
            return state;
    }
}

export function computersIsLoading(state = false, action) {
    switch (action.type) {
        case COMPUTERS_IS_LOADING:
            return action.isLoading;

        default:
            return state;
    }
}

export function computers(state = [], action) {
    switch (action.type) {
        case COMPUTERS_FETCH_DATA_SUCCESS:
            return action.computers;
   
        default:
            return state;
    }
}

export function computersCache(state = [], action) {
    switch (action.type) {
        case COMPUTERS_CREATE_CACHE:
            return action.computersCache;
          
        default:
            return state;
    }
}